import React from "react";
import "./FCSortableHeader.scss";

export type SortDirection = "asc" | "desc" | null;

export interface SortState<K extends string = string> {
    key: K | null;
    direction: SortDirection;
}

interface FCSortableHeaderProps<K extends string> {
    label: string;
    sortKey: K;
    sortState: SortState<K>;
    onSort: (key: K) => void;
    align?: "left" | "right" | "center";
}

/**
 * En-tête de colonne triable.
 * Affiche une icône qui reflète l'état du tri (neutre, ascendant, descendant).
 * Cliquer cycle entre asc → desc → neutre.
 */
function FCSortableHeader<K extends string>(props: FCSortableHeaderProps<K>) {
    const {label, sortKey, sortState, onSort, align = "left"} = props;
    const active = sortState.key === sortKey && sortState.direction !== null;
    const direction: SortDirection = active ? sortState.direction : null;

    const icon =
        direction === "asc" ? "keyboard_arrow_up" :
            direction === "desc" ? "keyboard_arrow_down" : "unfold_more";

    return (
        <button
            type="button"
            className={`fcSortableHeader fcSortableHeader-${align}${active ? " active" : ""}`}
            onClick={() => onSort(sortKey)}
        >
            <span className="fcSortableLabel">{label}</span>
            <span className={`material-symbols-outlined fcSortableIcon${active ? " active" : ""}`}>
                {icon}
            </span>
        </button>
    );
}

export default FCSortableHeader;
